import { render, staticRenderFns } from "./p32.vue?vue&type=template&id=1bd25774&scoped=true&"
import script from "./p32.vue?vue&type=script&lang=js&"
export * from "./p32.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bd25774",
  null
  
)

export default component.exports